import { render } from "./SubstractStockPackage.vue?vue&type=template&id=25b6726c&scoped=true"
import script from "./SubstractStockPackage.vue?vue&type=script&lang=js"
export * from "./SubstractStockPackage.vue?vue&type=script&lang=js"

import "./SubstractStockPackage.vue?vue&type=style&index=0&id=25b6726c&lang=scss&scoped=true"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b6726c"]])

export default __exports__